import {NodeLinkModel} from "../NodeLinkModel";
import React, {useEffect, useRef} from "react";

interface Props {
    model: NodeLinkModel;
    path: string
    selected: boolean
}

export const DataLinkSegment = React.forwardRef(({model, path, selected}: Props, ref) => {
    const refPath = useRef<SVGPathElement | any>();
    const refCircle = useRef<SVGCircleElement | any>();
    let percent = 0;

    const callback = (): (() => any) | undefined => {
        if (!refCircle || !refCircle.current || !refPath || !refPath.current) {
            return;
        }

        percent += 2;
        if (percent > 100) {
            percent = 0;
        }

        let point = refPath.current.getPointAtLength(refPath.current.getTotalLength() * (percent / 100.0));
        refCircle.current.setAttribute('cx', '' + point.x);
        refCircle.current.setAttribute('cy', '' + point.y);
        requestAnimationFrame(callback);
    };

    useEffect(() => {
        requestAnimationFrame(callback);
        return ()=>{

        }
    }, [])


    let stroke = "url(#grad-selected)"
    if(selected){
        stroke = "url(#grad)"
    }

    // console.log('data link segment', model, 'selected:', selected, 'path:', path)

    // return <path
    //         stroke={selected ? model.getOptions().selectedColor : model.getOptions().color}
    //         strokeWidth={3}
    //         d={path}
    //     />

    return <>
        <defs>
            <linearGradient id="grad" x1="0%" x2="100%" y1="0%" y2="0%">
                <stop offset="0%" style={{stopColor: "#5b5b5b"}}/>
                <stop offset="100%" style={{stopColor: "#989898"}}/>
            </linearGradient>

            <linearGradient id="grad-selected" x1="0%" x2="100%" y1="0%" y2="0%">
                <stop offset="0%" style={{stopColor: "#274479"}}/>
                <stop offset="100%" style={{stopColor: "#23a6b6"}}/>
            </linearGradient>
        </defs>
        <path
            fill="none"
            ref={refPath}
            strokeWidth={3} /*model.getOptions().width*/
            stroke={stroke}
            d={"M-1,-1," + path}
        />
    </>
})
